import "./finishes.css";
import React, { useRef, useEffect, useState } from "react";

import Arrow from "../../assets/images/icons/Icon-Freccia-menu.svg";
import { Link } from "react-router-dom";
import useRestList from "../_shared/hooks/useRestList";
import AppText from "../_shared/components/AppText";
import SlideImages from "../_shared/components/SlideImages";
import SideMenu from "../_shared/components/SideMenu";

import finiture from "../../assets/images/FinitureEColori_main.png";
import tessuti from "../../assets/images/tessuti.png";
import maniglie from "../../assets/images/maniglie.png";
import BackIcon from "../_shared/components/BackIcon";
import { Modal } from "antd";
import CloseIcon from "../_shared/components/CloseIcon";

function Finishes(props) {
  const { setSplash } = props;
  useEffect(() => setSplash(false), []);
  const [finishes] = useRestList("/finishes");
  const [fabrics] = useRestList("/fabrics");
  const [handles] = useRestList("/handles");

  const [selectedCategory, setSelectedCategory] = useState(-1);
  const [modalFinishes, setModalFinishes] = useState();
  const [modalIndex, setModalIndex] = useState();

  function renderMenu() {
    return (
      <div>
        <div className="row">
          <BackIcon></BackIcon>
          <div>
            <AppText bold>Finiture, tessuti e maniglie</AppText>
            <AppText light>Finishes, fabrics and handles</AppText>
          </div>
        </div>
        <div className="cards">
          <div className="cardStyle" onClick={() => setSelectedCategory(0)}>
            <img
              alt="finiture"
              src={finiture}
              style={{ height: 200, objectFit: "contain" }}
            ></img>
            <AppText bold small>
              Finiture e colori
            </AppText>
            <AppText small>Finishes and colours</AppText>
          </div>
          <div className="cardStyle" onClick={() => setSelectedCategory(1)}>
            <img
              alt="finiture"
              src={tessuti}
              style={{ height: 200, objectFit: "contain" }}
            ></img>
            <AppText small bold>
              Tessuti
            </AppText>
            <AppText small>Fabrics</AppText>
          </div>
          <div className="cardStyle" onClick={() => setSelectedCategory(2)}>
            <img
              alt="finiture"
              src={maniglie}
              style={{ height: 200, objectFit: "contain" }}
            ></img>
            <AppText small bold>
              Maniglie
            </AppText>
            <AppText small>Handles</AppText>
          </div>
        </div>
      </div>
    );
  }
  function getFabrics() {
    return fabrics
      ?.filter((main) => main?.parentFabric === undefined)
      ?.map((mainCat) => (
        <div style={{ marginLeft: 30 }}>
          <AppText small bold>
            {mainCat?.name?.it}
          </AppText>
          <AppText small light>
            {mainCat?.name?.en}
          </AppText>
          <div className="rowFinishes" style={{ marginTop: 5 }}>
            {fabrics
              ?.filter((sub) => sub?.parentFabric?.id === mainCat?.id)
              ?.map((subcat, index) => (
                <div
                  className="finishCard"
                  onClick={() => openFab(mainCat, index)}
                >
                  <img
                    alt=""
                    src={subcat?.image}
                    style={{ height: 140, width: 100 }}
                  ></img>
                  <div className="row">
                    <AppText fin bold>
                      {subcat?.code}
                    </AppText>
                    <AppText fin bold>
                      {subcat?.name?.it}
                    </AppText>
                  </div>
                  <AppText fin light>
                    {subcat?.description}
                  </AppText>
                </div>
              ))}
          </div>
        </div>
      ));
  }

  function openFin(subcat, index) {
    setModalFinishes(
      finishes.filter((x) => x?.parentFinish?.id === subcat?.id)
    );

    setModalIndex(index);
  }

  function openFab(subcat, index) {
    setModalFinishes(fabrics.filter((x) => x?.parentFabric?.id === subcat?.id));

    setModalIndex(index);
  }
  function openHandle(index) {
    setModalFinishes(handles);

    setModalIndex(index);
  }

  function getFinishes() {
    return finishes
      ?.filter((main) => main?.parentFinish === undefined)
      ?.filter((main) => main?.visible === true)
      ?.map((mainCat) => (
        <div style={{ marginLeft: 30 }}>
          <AppText small bold>
            {mainCat?.name?.it}
          </AppText>
          <AppText small light>
            {mainCat?.name?.en}
          </AppText>
          <div className="rowFinishes" style={{ marginTop: 5 }}>
            {finishes
              ?.filter((sub) => sub?.parentFinish?.id === mainCat?.id)
              ?.map((subcat, index) => (
                <div
                  className="finishCard"
                  onClick={() => openFin(mainCat, index)}
                >
                  <img
                    alt=""
                    src={subcat?.image}
                    style={{ height: 140, width: 100 }}
                  ></img>
                  <div className="rowFin">
                    <AppText fin bold>
                      {subcat?.code}
                    </AppText>
                    <AppText fin bold noSpace>
                      {subcat?.name?.it}
                    </AppText>
                  </div>
                  <AppText fin light>
                    {subcat?.description}
                  </AppText>
                </div>
              ))}
          </div>
        </div>
      ));
  }
  function getHandles() {
    return (
      <div style={{ marginLeft: 30, marginTop: 5 }} className="rowFinishes">
        {handles
          ?.filter((main) => main?.parentHandle === undefined)
          ?.map((mainCat, index) => (
            <div className="handleCard" onClick={() => openHandle(index)}>
              <img
                alt=""
                src={mainCat?.image}
                style={{ height: 250, width: 140 }}
              ></img>

              <AppText fin bold>
                {mainCat?.name?.it}
              </AppText>

              <AppText fin light>
                {mainCat?.description}
              </AppText>
            </div>
          ))}
      </div>
    );
  }
  function renderFinishes() {
    return (
      <div>
        <div className="row">
          <BackIcon onClick={() => setSelectedCategory(-1)}></BackIcon>
          <div style={{ marginBottom: 30 }}>
            <AppText bold> Finiture e colori</AppText>
            <AppText light>Finishes and colours</AppText>
          </div>
        </div>
        {getFinishes()}
      </div>
    );
  }

  function renderFabrics() {
    return (
      <div>
        <div className="row">
          <BackIcon onClick={() => setSelectedCategory(-1)}></BackIcon>
          <div style={{ marginBottom: 30 }}>
            <AppText bold> Tessuti</AppText>
            <AppText light>Fabrics</AppText>
          </div>
        </div>
        {getFabrics()}
      </div>
    );
  }

  function renderHandles() {
    return (
      <div>
        <div className="row">
          <BackIcon onClick={() => setSelectedCategory(-1)}></BackIcon>
          <div style={{ marginBottom: 30 }}>
            <AppText bold> Maniglie</AppText>
            <AppText light>Handles</AppText>
          </div>
        </div>
        {getHandles()}
      </div>
    );
  }

  return (
    <div className="rootMenu">
      <SideMenu></SideMenu>
      <div className="rootContent">
        {selectedCategory === -1 && renderMenu()}
        {selectedCategory === 0 && renderFinishes()}
        {selectedCategory === 1 && renderFabrics()}
        {selectedCategory === 2 && renderHandles()}
        <Modal
          closable={false}
          footer={[]}
          centered
          className="modal"
          bodyStyle={{ height: "85vh", overflowY: "auto" }}
          open={modalFinishes}
        >
          <div
            style={{
              alignSelf: "flex-end",
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <CloseIcon onClick={() => setModalFinishes()}></CloseIcon>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              marginLeft: "35%",
            }}
          >
            <SlideImages
              image={modalFinishes?.[modalIndex]?.image}
              onPlus={() =>
                modalFinishes.length > modalIndex + 1
                  ? setModalIndex(modalIndex + 1)
                  : setModalIndex(0)
              }
              onMinus={() =>
                modalIndex !== 0
                  ? setModalIndex(modalIndex - 1)
                  : setModalIndex(modalFinishes.length - 1)
              }
              showArrows={modalFinishes?.length > 1}
              style={{
                width: "30vw",
                objectFit: "cover",
                height: "70vh",
              }}
              noCenter
              noContain
            ></SlideImages>
            <div style={{ marginTop: 10 }}>
              <div className="rowNoSpace">
                {modalFinishes?.[modalIndex]?.code && (
                  <AppText small bold>
                    {modalFinishes?.[modalIndex]?.code}
                  </AppText>
                )}
                <AppText small bold>
                  {modalFinishes?.[modalIndex]?.name?.it}
                </AppText>
              </div>
              <AppText small light>
                {modalFinishes?.[modalIndex]?.description}
              </AppText>
            </div>
          </div>
        </Modal>
      </div>
    </div>
  );
}

export default Finishes;
